import {
  CAMPAIGN_REQUEST_BADGE_POLL_INTERVAL_MS,
  pollingOptions,
} from 'src/constants/polling.constants';
import { useGetNewCampaignRequestCountQuery } from '../endpoints/launched-campaigns.endpoints';

export function useNewCampaignRequestCount() {
  const { data } = useGetNewCampaignRequestCountQuery(
    undefined,
    pollingOptions(CAMPAIGN_REQUEST_BADGE_POLL_INTERVAL_MS),
  );

  return data?.count ?? 0;
}
